// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"1b087cae","513":"8f6cb0b2","545":"05f847c0"}[chunkId] + ".chunk.js";
};